export interface IAdminUser {
  administrator_code?: string;
  administrator_name?: string;
  login_id?: string;
  login_password?: string;
}

export class AdminUserDTO implements IAdminUser {
  administrator_code?: string;
  administrator_name?: string;
  login_id?: string;
  login_password?: string;
}

export default class AdminUser extends AdminUserDTO {
  original = {};
  constructor(dto?: AdminUserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }
  public new() {
    Object.assign(this, {
      administrator_code: "",
      administrator_name: "",
    });
  }
}
